<template>
  <v-dialog :value="value" max-width="400" @input="$emit('input', $event)">
    <div class="text-center">
      <v-sheet
        class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
        color="white"
        style="width: 100%"
      >
        <h3 class="mb-4">
          {{ $t('Salvar Inventário') }}
        </h3>

        <v-divider class="mb-4"></v-divider>

        <p class="text-body-2 black--text mb-6">
          {{
            $t(
              'Os dados serão salvos e os equipamentos serão gerados. Deseja prosseguir?'
            )
          }}
        </p>

        <div class="d-flex justify-space-between">
          <v-btn
            :disabled="loading"
            depressed
            class="ma-1 secondary-button"
            style="color: white; background-color: #FF4F64 !important"
            @click="$emit('input', false)"
          >
            {{ $t('Não') }}
          </v-btn>

          <v-btn
            :loading="loading"
            depressed
            class="ma-1 primary-button"
            color="#0F3582"
            style="color: white"
            @click="$emit('confirm')"
          >
            {{ $t('Sim') }}
          </v-btn>
        </div>
      </v-sheet>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmImportDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
